/**
 * Centralized course/topic definitions
 *
 * For display names and course behavior, use courseService.js instead.
 * This file provides constants for type-safe topic/batch references.
 */

import { getCourseDisplayName, isValidCourse, getAllCourseIds } from '../services/courseService';

// Topic identifiers (for type-safe references)
export const TOPICS = {
  PHONICS: 'phonics',
  SOUTHSTREET: 'southstreet',
  SONGS: 'songs',
  PIGGY: 'piggy',
  MONKEYKING: 'monkeyking',
  ATOMICHABITS: 'atomichabits',
  NAVALMANACK: 'navalmanack',
  NCE1: 'nce1',
  NCE2: 'nce2',
  NCE3: 'nce3',
  NCE4: 'nce4',
  CLASSICCHINESESTORIES: 'classicchinesestories',
};

// Batch identifiers
export const BATCHES = {
  B1: 'b1',
  B2: 'b2',
  B3: 'b3',
  B4: 'b4',
};

// Assignment types
export const ASSIGNMENT_TYPES = {
  NORMAL: 'normal',
  REVIEW: 'review',
  CURRICULUM: 'curriculum',
};

// Re-export from courseService for backwards compatibility
// Consumers should migrate to using courseService directly
export const getTopicDisplayName = getCourseDisplayName;
export const isValidTopic = isValidCourse;
export const getAllTopics = getAllCourseIds;
